import React from 'react'
import Home from './Home'
import Productlist from './Productlist'
import TopHeader from './TopHeader'
import Header from './Header'
import BottomHeader from './BottomHeader'
import Footer from './Footer'



function Layout({children}) {
 
  return (
    <>
       {/* <TopHeader /> */}
        <Header/>
        {/* <BottomHeader /> */}
        {children}
        <Footer />
      
      
    </>
    
  )
}

export default Layout